import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85d2e4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game" }
const _hoisted_2 = { class: "game__score" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "game__ticks" }
const _hoisted_5 = { class: "game__container" }
const _hoisted_6 = { class: "game__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "game__trampoline" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "game__trampoline--ascii" }, [
    /*#__PURE__*/_createElementVNode("div", null, "----------"),
    /*#__PURE__*/_createElementVNode("div", null, "|        |")
  ])
], -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createTextVNode(" Score: " + _toDisplayString(_ctx.score), 1),
        (_ctx.scoreIncrease)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" (+" + _toDisplayString(_ctx.scoreIncrease) + ")", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, "  Time: " + _toDisplayString(Math.ceil(_ctx.time / 1000)), 1),
      (_ctx.bestTrampoline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "  Best: " + _toDisplayString(_ctx.bestTrampoline), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (x, idx) => {
        return _createElementVNode("div", {
          class: "game__tick",
          key: idx
        }, _toDisplayString(((10 - idx) ** 2) * $data.tickScale), 1)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "game__character",
          style: _normalizeStyle(`top: ${100 - _ctx.height}%`)
        }, "[YOU]", 4)
      ]),
      _hoisted_7
    ])
  ]))
}